import React from "react";
import { useNavigate} from 'react-router-dom';
import '../css/image_card.css';

const ImageCard = ({src,title,route})=>{
const navigate = useNavigate();

const handleClick=()=>{
navigate(route,{
    state:{imageSrc:src,title:title},
});
};
    return (
    
            <div className="image-card" onClick={handleClick}>
                <img src={src} alt={title} className="card-image" />
                <div className="card-text">
                    <h3>{title}</h3>
                </div>
            </div>
       

    );


}

export default ImageCard;